import { createContext, useContext, useState } from 'react';

const ProjectContext = createContext(null);

export function ProjectProvider({ children }) {
  const [projectId, setProjectId] = useState(() => {
    const v = localStorage.getItem('currentProjectId');
    return v || null;
  });
  const [projectName, setProjectName] = useState(() =>
    localStorage.getItem('currentProjectName') || ''
  );
  const [projectImage, setProjectImage] = useState(() =>
    localStorage.getItem('currentProjectImage') || ''
  );

  const selectProject = (project) => {
    setProjectId(project.id);
    setProjectName(project.name);
    setProjectImage(project.imageUrl || '');
    localStorage.setItem('currentProjectId', project.id);
    localStorage.setItem('currentProjectName', project.name);
    localStorage.setItem('currentProjectImage', project.imageUrl || '');
  };

  const clearProject = () => {
    setProjectId(null);
    setProjectName('');
    setProjectImage('');
    localStorage.removeItem('currentProjectId');
    localStorage.removeItem('currentProjectName');
    localStorage.removeItem('currentProjectImage');
  };

  return (
    <ProjectContext.Provider value={{ projectId, projectName, projectImage, selectProject, clearProject }}>
      {children}
    </ProjectContext.Provider>
  );
}

export function useProject() {
  return useContext(ProjectContext);
}
